const enc = encodeURIComponent;
const qs = (params) => {
    const parts = Object.entries(params).filter(([, v]) => v !== undefined && v !== '').map(([k, v]) => `${k}=${enc(v)}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
};
export class KycCatalogAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** A country's catalog: the version in force, the pending change, the history. */
    get(country) {
        return this.client.request({ method: 'GET', path: `/v1/admin/kyc-catalog${qs({ country })}`, auth: true });
    }
    /** The countries that have a catalog. */
    countries() {
        return this.client.request({ method: 'GET', path: '/v1/admin/kyc-catalog', auth: true });
    }
    /** Propose a new catalog version (the maker). */
    propose(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/kyc-catalog/changes', body: input, auth: true });
    }
    /** Approve a pending version (the checker — never its proposer). */
    approve(country, version, reason) {
        return this.decide(country, version, 'approve', reason);
    }
    reject(country, version, reason) {
        return this.decide(country, version, 'reject', reason);
    }
    /** Withdraw one's own pending proposal. */
    withdraw(country, version, reason) {
        return this.decide(country, version, 'withdraw', reason);
    }
    decide(country, version, action, reason) {
        return this.client.request({ method: 'POST', path: `/v1/admin/kyc-catalog/changes/${enc(country)}/${version}/${action}`, body: { reason }, auth: true });
    }
}
export class DriverEnablementAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The market's drivers and where each stands (per category and as a courier). */
    marketDrivers(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-eligibility${qs({ marketId })}`, auth: true });
    }
    /** One driver's documents: the catalog types, every review line, the vehicles, and the decisions. */
    driverDocuments(driverId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/drivers/${enc(driverId)}/documents`, auth: true });
    }
    /** Record one in-person review line (the reviewer is the session). */
    reviewDocument(driverId, line) {
        return this.client.request({ method: 'POST', path: `/v1/admin/drivers/${enc(driverId)}/documents/reviews`, body: line, auth: true });
    }
    /** The vehicles the market's drivers registered (optionally one status or one driver), with their latest inspection. */
    vehicles(marketId, filter = {}) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-vehicles${qs({ marketId, status: filter.status, driverId: filter.driverId })}`, auth: true });
    }
    vehicleInspections(vehicleId, marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-vehicles/${enc(vehicleId)}/inspections${qs({ marketId })}`, auth: true });
    }
    /** Record an operator inspection (the inspector is the session). */
    inspectVehicle(vehicleId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/driver-vehicles/${enc(vehicleId)}/inspections`, body: input, auth: true });
    }
}
export class DriverEligibilityApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The driver's own eligibility: per category and as a courier, with the reasons (DRIVER session only). */
    eligibility() {
        return this.client.request({ method: 'GET', path: '/v1/driver/eligibility', auth: true });
    }
    /** The documents the driver's market requires, with the standing and validity of each (DRIVER session only). */
    documents() {
        return this.client.request({ method: 'GET', path: '/v1/driver/documents', auth: true });
    }
}
//# sourceMappingURL=driver-eligibility.js.map